module.exports = __webpack_public_path__ + "static/media/Barmag Nip Roller Bearing.f08a3573.jpg";